import React from "react";

export default function Coordonnees({ settings, handleChange, disabled = false }) {
  const inputClass =
    "w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40";
  const labelClass = "block text-xs font-extrabold uppercase text-gray-600 dark:text-gray-300";

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div>
        <label className={labelClass}>Adresse</label>
        <input
          type="text"
          name="adresse_club"
          value={settings.adresse_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Entrez l'adresse"
        />
      </div>

      <div>
        <label className={labelClass}>Commune</label>
        <input
          type="text"
          name="commune_club"
          value={settings.commune_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Entrez la commune"
        />
      </div>

      <div>
        <label className={labelClass}>Téléphone</label>
        <input
          type="text"
          name="tel_club"
          value={settings.tel_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Entrez le téléphone"
        />
      </div>

      <div>
        <label className={labelClass}>Email</label>
        <input
          type="text"
          name="mail_club"
          value={settings.mail_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Entrez l'email"
        />
      </div>

      <div>
        <label className={labelClass}>Site web</label>
        <input
          type="text"
          name="siteweb_club"
          value={settings.siteweb_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Entrez le site web"
        />
      </div>

      <div>
        <label className={labelClass}>Facebook</label>
        <input
          type="text"
          name="facebook_club"
          value={settings.facebook_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="URL Facebook"
        />
      </div>

      <div>
        <label className={labelClass}>Instagram</label>
        <input
          type="text"
          name="instagram_club"
          value={settings.instagram_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="URL Instagram"
        />
      </div>

      <div className="flex items-center gap-3">
        <div className="flex-1">
          <label className={labelClass}>Couleur primaire</label>
          <input
            type="color"
            name="primary_color"
            value={settings.primary_color || "#000000"}
            onChange={handleChange}
            disabled={disabled}
            className="w-full h-10 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800"
          />
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-6">
          {settings.primary_color || "#000000"}
        </div>
      </div>
    </div>
  );
}
